// Contraseñas en la vista previa del navegador: SHA-256 con sal (crypto.subtle). Sirve solo para la demostración con datos de prueba.
const hex = (b: ArrayBuffer | Uint8Array) => [...new Uint8Array(b)].map((x) => x.toString(16).padStart(2, "0")).join("");
export const nuevaSal = () => hex(crypto.getRandomValues(new Uint8Array(16)));
export async function hashSha(clave: string, sal: string): Promise<string> {
  return hex(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(`${sal}:${clave}`)));
}
/** Comparación sin salida anticipada. */
export function iguales(a: string, b: string) {
  let d = a.length ^ b.length;
  for (let i = 0; i < Math.max(a.length, b.length); i++) d |= (a.charCodeAt(i) || 0) ^ (b.charCodeAt(i) || 0);
  return d === 0;
}
